export default {
    "SETTINGS": {
        "target": "Target date",
        "ad_url": "Middle tile url",
        "contact_email": "Form email address",
        "main_page_text": "Main page text HU",
        "main_page_text_hu": "Main page text HU",
        "main_page_text_en": "Main page text EN",
        "main_page_image": "Main page image",
        "form_fazekas": "Űrlap: Fazekastalálkozó",
        "form_vendeglatos": "Űrlap: Vendéglátósok",
        "form_maganudvar": "Űrlap: Magánudvar",
        "form_malomudvar": "Űrlap: Malomsziget",
        "form_kastelyudvar": "Űrlap: Malomsziget",
        "gallery_intro_en": "Galléria intró EN",
        "gallery_intro_hu": "Galléria intró HU",
        "main_page_programs_link": "Programs Sections Link",
        "main_page_link": "Main Page Link",
        "main_page_logo": "Main Page Logo HU",
        "main_page_logo_hu": "Main Page Logo HU",
        "main_page_logo_en": "Main Page Logo EN",
        "main_page_counter_en": "Main Page Counter Text EN",
        "main_page_counter_hu": "Main PAge Counter Text HU",
        "main_page_categories_header_hu": "Main page categories header HU",
        "main_page_categories_header_en": "Main page categories header EN",
        "app_url_android": "App Url Android",
        "app_url_ios": "App Url iOS",
        'main_page_youtube_embed': 'Youtube embed id',
        'main_page_galleries_header_hu': 'Gallery header HU',
        'main_page_galleries_header_en': 'Gallery header EN',
        'main_page_tickets_header_hu': 'Tickets header HU',
        'main_page_tickets_header_en': 'Tickets header EN',
        'page_title_hu': 'Page Title HU',
        'page_title_en': 'Page Title EN',
        'page_description_hu': 'Page Description HU',
        'page_description_en': 'Page Description EN',
        'date_from': 'Date Start',
        'date_to': 'Date End',
        'social_instagram': 'Instagram link',
        'social_facebook': 'Facebook link',
        'social_youtube': 'Youtube link',
        'social_spotify': 'Spotify link',
        'webshop_title_hu': 'Webshop Title HU',
        'webshop_title_en': 'Webshop Title EN',
        'webshop_description_hu': 'Webshop Description HU',
        'webshop_description_en': 'Webshop Description EN',
        'webshop_link_text_hu': 'Webshop Link Text HU',
        'webshop_link_text_en': 'Webshop Link Text EN',
        'webshop_link': 'Webshop Link',
        'main_page_ticket_button_hu': 'Tickets button text HU',
        'main_page_ticket_button_en': 'Tickets button text EN',
        'main_page_programs_button_hu': 'Programs button text HU',
        'main_page_programs_button_en': 'Programs button text EN',
        'webshop_image': 'Webshop kép',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/settings.js